import FetchClient from "./FetchClient";

export interface ChatMessage {
  role: "user" | "assistant";
  content: string;
}

export interface ChatRequest {
  message: string;
  zipCode: string;
  history?: ChatMessage[];
  radiusKm?: number;
  language?: "en" | "es";
}

export interface SearchQuery {
  keywords: string;
  maxPrice?: number;
  minPrice?: number;
  category?: string;
  retailers?: string[];
  sortBy?: "price" | "discount" | "relevance";
  onlyDeals?: boolean;
  minDiscount?: number;
}

export interface ProductResult {
  upc: string;
  sku: string;
  name: string;
  price: number;
  msrp?: number;
  discount?: number;
  image?: string;
  url?: string;
  retailer: string;
  storeId?: string;
  storeAddress?: string;
  category?: string;
  inStock: boolean;
  lastUpdated?: number;
}

export interface ChatResponse {
  message: string;
  products?: ProductResult[];
  query?: SearchQuery;
  error?: string;
}

export const sendChatMessage = async (request: ChatRequest): Promise<ChatResponse> => {
  const response = await FetchClient.post<ChatResponse>("/ai-chat", request);
  return response;
};
